// extracted by mini-css-extract-plugin
module.exports = {"service-page":"ServicePage_service-page__L8LP7","title":"ServicePage_title__2oy0v","show-info":"ServicePage_show-info__3Z26n","chevron-icon":"ServicePage_chevron-icon__1ZvZy"};